module.exports = __webpack_public_path__ + "media/images/criteo_small_logo-8a11e5be79f9ebdb28ce5bb03f2bee61.png";